/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { Currency } from '../../../shared';
import {
  CreateOrderAction,
  CreateOrderActionTypes,
  CreateOrderFormFields,
  CreateOrderState,
  ValidationErrors,
} from './types';
import { validateOrder } from './validation';

export const initialCreateOrderState: CreateOrderState = {
  order: {
    trackingNumber: '',
    name: '',
    parcelCount: undefined,
    amount: {
      amount: undefined,
      currency: Currency.USD,
    },
    store: {
      name: '',
    },
    deliveryAddress: {
      address: '',
    },
  },
  success: false,
  loading: false,
  validationErrors: {},
};

export default function createOrderReducer(state = initialCreateOrderState, action: CreateOrderAction) {
  switch (action.type) {
    case CreateOrderActionTypes.CREATE_ORDER_REQUEST:
      return update(state, {
        success: { $set: false },
        loading: { $set: true },
      });

    case CreateOrderActionTypes.CREATE_ORDER_SUCCESS:
      return update(state, {
        success: { $set: true },
        loading: { $set: false },
        order: { $set: initialCreateOrderState.order },
        validationErrors: { $set: {} },
        $unset: ['error'],
      });

    case CreateOrderActionTypes.CREATE_ORDER_ERROR:
      return update(state, {
        success: { $set: false },
        loading: { $set: false },
        error: { $set: action.error },
      });

    case CreateOrderActionTypes.RESET_ERROR:
      return update(state, {
        $unset: ['error'],
      });

    case CreateOrderActionTypes.UPDATE_CREATE_ORDER_FIELDS:
      const clearedErrors = { ...state.validationErrors };
      const fieldName = Object.keys(action.fields)[0] as keyof ValidationErrors;

      if (fieldName && clearedErrors[fieldName]) {
        delete clearedErrors[fieldName];
      }

      return update(state, {
        order: {
          $merge: action.fields as Partial<CreateOrderFormFields>,
        },
        validationErrors: { $set: clearedErrors },
      });

    case CreateOrderActionTypes.VALIDATION_ALL_FIELDS:
      const validationErrors = validateOrder(state.order, action.options);

      return update(state, {
        validationErrors: { $set: validationErrors },
        loading: { $set: Object.keys(validationErrors).length > 0 ? false : true },
      });

    case CreateOrderActionTypes.RESET_CREATE_ORDER_STATE:
      return initialCreateOrderState;

    default:
      return state;
  }
}
